export const getErrorForPath = (issues, path) => {
  const issue = issues?.find((issue) => {
    return issue.path.join(".") === path.join(".");
  });

  return issue;
};
